const data = {
  id: 0,
  curation: require("./5/curation").default,
};

export default data;
